import classnames from 'classnames';
import React from 'react';

import { format } from 'src/lib/format';
import { countAddedAndDeletedTypes } from 'src/lib/graphql/graphqlHelpers';

export const TypeAndFieldDiffCount = ({
  modifiedSchemaTypeCount,
  modifiedSchemaFieldCount,
  typesAdded,
  typesRemoved,
  fieldsAdded,
  fieldsRemoved,
  className,
}: Omit<
  ReturnType<typeof countAddedAndDeletedTypes>,
  'baseSchemaTypeCount' | 'baseSchemaFieldCount'
> & { className?: string }) => (
  <div className={classnames('flex items-center text-secondary', className)}>
    <div className="mr-2">
      <span className="font-semibold">{modifiedSchemaTypeCount}</span>{' '}
      {format.pluralize(modifiedSchemaTypeCount, 'type')}{' '}
      {(typesAdded > 0 || typesRemoved > 0) && (
        <span className="space-x-1">
          (
          {typesRemoved > 0 && (
            <span className="font-semibold text-error">-{typesRemoved}</span>
          )}
          {typesAdded > 0 && (
            <span className="font-semibold text-success">+{typesAdded}</span>
          )}
          )
        </span>
      )}
    </div>
    <div className="mr-2">
      <span className="font-semibold">{modifiedSchemaFieldCount}</span>{' '}
      {format.pluralize(modifiedSchemaFieldCount, 'field')}{' '}
      {(fieldsAdded > 0 || fieldsRemoved > 0) && (
        <span className="space-x-1">
          (
          {fieldsRemoved > 0 && (
            <span className="font-semibold text-error">-{fieldsRemoved}</span>
          )}
          {fieldsAdded > 0 && (
            <span className="font-semibold text-success">+{fieldsAdded}</span>
          )}
          )
        </span>
      )}
    </div>
  </div>
);
